/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentDescription_development$ref: FragmentReference;
declare export opaque type DevelopmentDescription_development$fragmentType: DevelopmentDescription_development$ref;
export type DevelopmentDescription_development = {|
  +description: ?string,
  +$refType: DevelopmentDescription_development$ref,
|};
export type DevelopmentDescription_development$data = DevelopmentDescription_development;
export type DevelopmentDescription_development$key = {
  +$data?: DevelopmentDescription_development$data,
  +$fragmentRefs: DevelopmentDescription_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentDescription_development",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'db82d89a91ab89a6f95a19be9ea39b2c';

export default node;
